export default "__VITE_ASSET__DXFAF4Nh__"